import { useNavigate, useLocation } from "react-router-dom"
import { Home, FileText, CalendarDays, TrendingUp, User } from "lucide-react"

const NAV_ITEMS = [
  { id: "home", label: "Accueil", icon: Home, path: "/dashboard" },
  { id: "sessions", label: "Séances", icon: FileText, path: "/dashboard/sessions" },
  { id: "calendar", label: "Calendrier", icon: CalendarDays, path: "/dashboard/calendar" },
  { id: "progress", label: "Progrès", icon: TrendingUp, path: "/dashboard/progress" },
  { id: "profile", label: "Profil", icon: User, path: "/dashboard/profile" },
]

export const BottomNav = () => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 px-3.5 pt-4 pointer-events-none"
      style={{
        background: "linear-gradient(180deg, rgba(6,10,19,0) 0%, rgba(6,10,19,0.85) 35%, rgba(6,10,19,0.98) 100%)",
        // Au-dessus de la barre d'accueil de l'iPhone (viewport-fit=cover, lot 3) :
        // 24 px comme avant, ou la zone de sécurité + 8 px si elle est plus haute.
        paddingBottom: "max(24px, calc(env(safe-area-inset-bottom) + 8px))",
      }}
    >
      <div
        className="grid grid-cols-5 gap-0.5 p-1.5 rounded-[22px] pointer-events-auto"
        style={{
          background: "rgba(10,15,25,0.85)",
          border: "1px solid rgba(31,41,55,0.6)",
          backdropFilter: "blur(24px)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.04)",
        }}
      >
        {NAV_ITEMS.map((item) => { const isActive = location.pathname === item.path; const Icon = item.icon; return (
          <button key={item.id} onClick={() => navigate(item.path)} className="relative flex flex-col items-center gap-1 py-1.5 rounded-2xl cursor-pointer transition-colors">
            {isActive && (
              <span
                className="absolute -top-px left-1/2 -translate-x-1/2 w-[20px] h-[2px] rounded-full"
                style={{ background: "#06b6d4", boxShadow: "0 0 8px #06b6d4" }}
              />
            )}
            <div
              className="w-8 h-8 rounded-xl flex items-center justify-center transition-colors"
              style={{ background: isActive ? "radial-gradient(circle, rgba(6,182,212,0.22), rgba(6,182,212,0.04) 70%)" : "transparent" }}
            >
              <Icon className="w-[19px] h-[19px] transition-colors" style={{ color: isActive ? "#06b6d4" : "#64748b" }} strokeWidth={isActive ? 2.2 : 1.8} />
            </div>
            <span className="text-[9.5px] transition-colors" style={{ color: isActive ? "#06b6d4" : "#64748b", fontWeight: isActive ? 700 : 500 }}>
              {item.label}
            </span>
          </button>) })}
      </div>
    </div>
  )
}
